import React, {useRef, useState} from 'react';
import styles from "./required-documents.module.scss";
import {Col, Row, Table, Button, Spinner, ProgressBar} from "react-bootstrap";
import acceptIcon from "../../../../../../assets/orders-table-accept.svg";
import pendingIcon from "../../../../../../assets/orders-table-pending.svg";
import rejectIcon from "../../../../../../assets/orders-table-reject.svg";
import SecurityDetailsModalContent from "../security-details-modal-content/security-details-modal-content";
import ModalCustom from "../../../../../../components/modal/modal";
import UploadModalContent from "../upload-modal-content/upload-modal-content";
import ListingService from "../../../../../../services/listing-service";

const RequiredDocuments = ({context}) => {
  const selectedDocument = useRef({});
  const [loading, setLoading] = useState(false);
  //Modal State
  const [showModal, setShowModal] = useState(false);
  const { applicationId, requiredDocuments, setRequiredDocuments, institutionCode, editAllowed} = context;
  const listingService = new ListingService();

  const tableHeaders = [
    // {value: 'Group', class: ''},
    {value: 'Document Name', class: ''},
    {value: 'Status', class: ''}
  ]

  const renderStatus = (doc) => {
    switch(doc.documentStatus){
      case '1':
        return <span><img alt="Submitted" src={acceptIcon}/>  Submitted</span>
      case '0':
        return <span><img alt="Pending" src={pendingIcon}/>  Pending</span>
      case '2':
        return <span><img alt="Approved" src={acceptIcon}/>  Approved</span>
      case '3':
        return <span><img alt="Rejected" src={rejectIcon}/>  {`Rejected (${doc.reason})`}</span>
      default:
    }
  }

  const renderAction = document => {
    const status = document.documentStatus;
    switch(status) {
      case '1':
        return <div className={styles['button-action']}>
          <Button variant="secondary" onClick={() => viewDocument(document)}>VIEW</Button>
          {editAllowed() ? <Button disabled={loading} onClick={() => deleteDocument(document)}>
            { loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"/>: 'DELETE' }
          </Button> :''}
        </div>
      case '2':
        return <div className={styles['button-action']}>
          <Button variant="secondary" onClick={() => viewDocument(document)}>VIEW</Button>
        </div>
      case '3':
        return <div className={styles['button-action']}>
          <Button variant="secondary" onClick={() => viewDocument(document)}>VIEW</Button>
          {editAllowed() ? <Button disabled={loading} onClick={() => deleteDocument(document)}>
            { loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"/>: 'DELETE' }
          </Button> :''}
        </div>
      default:
        return <div className={styles['button-action']}>
          {editAllowed() ? <Button onClick={() => showUploadModal(document)}>UPLOAD</Button> :''}
        </div>
    }
  }

  const showUploadModal = document => {
    selectedDocument.current = document;
    setShowModal(true);
  }

  const viewDocument = async document => {
    try {
      const result = await listingService.retrieveRequiredDocument(applicationId, document.sortKey, document.key, institutionCode);
      const newWindow = window.open(result['url'], '_blank', 'noopener,noreferrer');
      if (newWindow) newWindow.opener = null;
    } catch(error) {}
  }

  const deleteDocument = async document => {
    try {
      setLoading(true)
      const result = await listingService.deleteRequiredDocument(applicationId, document.sortKey, document.key, institutionCode);
      setRequiredDocuments(prev => {
        const updatedList = prev.map(d => {
          if(d.sortKey === document.sortKey){
            return {
              ...d,
              documentStatus: '0'
            }
          }
          return d
        });
        return updatedList
      });
    } catch(error) {}
    finally {
      setLoading(false)
    }
  }

  const computePercentage = () => {
    console.log(requiredDocuments.filter(d => d.documentStatus == '1').length);
    return Math.trunc((requiredDocuments.filter(d => d.documentStatus == '2').length / requiredDocuments.length) * 100);
  }

  return (
    <div className={`${styles['required-documents']} ${styles['panel']}`} >
      <Row>
        <Col>
          <div className={styles['table-heading']}>
            Documentary Requirements for Listing / Enrollment - Checklist and Completion Status
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className={styles['term-sheet-status']}>
            Status:
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={4}>
          <div>
            <ProgressBar className={styles['progress']} now={computePercentage()} label={`${computePercentage()}%`} />
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <Table responsive>
            <thead>
            <tr>
              {tableHeaders.map(
                (header, index) => {
                  return <th className={styles[header['class']]} key={index}>{header.value}</th>
                }
              )}
            </tr>
            </thead>
            <tbody>
            {
              requiredDocuments.map((d, index) => {
                return (
                  <tr key={index}>
                    {/* <td >{d.group}</td> */}
                    <td className={styles['document-name']}>{d.documentName}</td>
                    <td>{renderStatus(d)}</td>
                    <td>{renderAction(d)}</td>
                  </tr>
                )
              })
            }
            </tbody>
          </Table>
          {
            requiredDocuments.length > 0 ? ''
              : <div className={styles['no-data']}>No required documents to display.</div>
          }
        </Col>
      </Row>
      <ModalCustom
        show={showModal}
        title="Upload Document"
        onClose={() => setShowModal(false)}
        component={<UploadModalContent context={{applicationId, selectedDocument, setRequiredDocuments, institutionCode}} onClose={() => setShowModal(false)}/>}
        style={styles['upload-documents-modal']} />
    </div>
  )
}

export default RequiredDocuments;
